import React from 'react';

const Logo = () => {
  return(
    <div className="logo-label">ProfitDesk</div>
  );
}

export default Logo;